import React, { useMemo } from "react";
import { useControl, useControlReducer } from "../../../controlContext";
import { Dropdown } from "react-bootstrap";
import { RAT } from "../../../../../shared/Data/typeDirs";
import { useSource } from "../../../sourceContext";
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/ratings.css'
import { useControlHeaderContext } from "../../../controlWrapperContext";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const color_order = ['outline-info', 'danger', 'warning', 'success', 'primary']
export function RatingsControl({ idx, name }) {
  const { [idx]: { [name]: value, _id } } = useControl()
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[_id])), [allReadOnly, lockMap, _id])

  const controlReducer = useControlReducer()
  const { [RAT]: ratings } = useSource()

  const ratingIndex = useMemo(() => {
    const ratingIdx = ratings.findIndex(rat => rat._id === value)
    // console.log('new rating index', ratingIdx)
    return ratingIdx
  }, [ratings, value])
  return (
    <div className="report-ratings-container">
    <Dropdown onSelect={(evt) => {
        console.log('selected rating', evt)
        controlReducer({ idx, name, type: 'changed', update: { [name]: evt } })
      }}>
        <Dropdown.Toggle
          disabled={readOnly}
          variant={value ? color_order[ratingIndex] : color_order[0]}
          style={color_map[color_order[ratingIndex]]}
          className="report-ratings-dropdown" >
          {value ? ratings.find(rat => rat._id === value).getDisplayText().slice(2) : ratings[0].getDisplayText().slice(2)}
          {readOnly ? [] : (
            <KeyboardArrowDownIcon sx={{ ml: 1}}/>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {ratings.map((rat, iRat) => <Dropdown.Item key={rat._id} style={color_map[color_order[iRat]]} eventKey={rat._id}>{rat.getDisplayText()}</Dropdown.Item>)}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

const color_map = {
  'outline-info':
  {
    borderWidth: 2,
    fontWeight: 'bold',
  },
  danger: {
    color: '#fff',
    backgroundColor: '#c82333FF',
    borderColor: '#bd213099',
    borderWidth: 2,
    fontWeight: 'bold',
    opacity:1
  },
  warning: {
    backgroundColor: '#e0a800FF',
    borderColor: '#d39e0099',
    borderWidth: 2,
    fontWeight: 'bold',
    color: '#21252999',
    opacity:1
  },
  success: {
    color: '#fff',
    backgroundColor: '#218838FF',
    borderColor: '#1e7e3499',
    borderWidth: 2,
    fontWeight: 'bold',
    opacity:1
  },
  primary: {
    color: '#fff',
    backgroundColor: '#025ce2FF',
    borderColor: '#0257d599',
    borderWidth: 2,
    fontWeight: 'bold',
    opacity:1
  }
}

